<template>
  <div class="row p-2">
    <div class="col">
      <!-- <div>
        <div class="pull-left">
          <a class="btn btn-success" href="#" @click="addtab">Add Field</a>
        </div>
        <br />
      </div> -->

      <label class="font-bold">Deployed Relationships</label>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>Primary Module</th>
            <th>Type</th>
            <th>Related Module</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <!-- <tr v-for="(value, key) in field_List" v-bind:key="key" @click="editfield(key)"> -->
          <tr v-for="(value, key) in field_List" v-bind:key="key">
            <td>{{ value.name }}</td>
            <td>{{ value.pmodule }}</td>
            <td>{{ value.relation }}</td>
            <td>{{ value.rmodule }}</td>
            <!-- <td>
              <i
                class="fas fa-edit p-2 rounded bg-green-500 text-white mr-1"
                @click="editfield(value)"
              ></i>
              <i
                class="fas fa-trash-alt p-2 rounded bg-red-500 text-white"
                @click="
                  deleteRelationship(value.name, value.rmodule, value.pmodule)
                "
              ></i>
            </td> -->
          </tr>
        </tbody>
      </table>

      <label class="font-bold">Undeployed Relationships</label> <br>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>Primary Module</th>
            <th>Type</th>
            <th>Related Module</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <!-- <tr v-for="(value, key) in field_List" v-bind:key="key" @click="editfield(key)"> -->
          <tr v-for="(value, key) in undeployed_field_List" v-bind:key="key">
            <td>{{ value.name }}</td>
            <td>{{ value.pmodule }}</td>
            <td>{{ value.relation }}</td>
            <td>{{ value.rmodule }}</td>
            <td>
              <i
                class="fas fa-edit p-2 rounded bg-green-500 text-white mr-1"
                @click="editfield(value)"
              ></i>
              <i
                class="fas fa-trash-alt p-2 rounded bg-red-500 text-white"
                @click="
                  deleteRelationship(value.name, value.rmodule, value.pmodule)
                "
              ></i>
            </td>
          </tr>
        </tbody>
      </table>


    </div>
  </div>
</template>

<script>

import { confirm } from "devextreme/ui/dialog";
import { alert } from "devextreme/ui/dialog";


export default {
  props: ["modulekey", "studio", "slug"],
  mounted() {
    //console.log('Component mounted.')
    this.getFieldslist();
  },
    components: {
    confirm,
    alert,
  },
  data() {
    return {
      field_List: new Object(),
      undeployed_field_List: new Object(),

    };
  },
  methods: {
    deleteRelationship(dataField, rModule, pModule) {
      this.errors = {};

      axios
        .get("/" + this.slug + "/deleteRelationship", {
          params: {
            relate_name: dataField,
            rModule: rModule,
            pModule: pModule,
            modulekey: this.modulekey,
          },
        })
        .then((response) => {
          window.location.href =
            "/" + this.slug +    "/module/" + this.modulekey+"/relationships";
         // window.location.href = "/builder/add_relationships/" + this.modulekey;
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
          } //alert("error");
        });
    },
    cancell() {
      alert("first tab");
    },
    addtab() {
      addTab("#add_field");
      //this.$root.$refs.add_field.clear();
      //this.$root.$refs.add_field.getDDList();
    },
    editfield(value) {
      //addTab("#add_field");

     console.log("Relationship list EDIT KEY",value.name);

      if (!value.name.endsWith("_c")&& this.slug=='studio') {
          
        let alertRes = alert("You Can't Update and Delete Default Relationship From Studio", "Alert!");
        alertRes.then((dialogResult) => {});


      }else{

           this.$emit("send", {
        "tabindex": 1,
        "tabData": value,
        "editmode":true,

      });

      }


  

      //this.$root.$refs.add_field.showfield(key);
    },
    getFieldslist() {
      this.errors = {};
      axios
        .get("/" + this.slug + "/relationship", {
          params: {
            module: this.modulekey,
            studio: this.studio,
          },
        })
        .then((response) => {
          console.log("relationship", response.data);
          this.field_List =  response.data.deployed;
          this.undeployed_field_List = response.data.undeployed;

          //alert("kk");
          //console.log(this.field_List);
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
          } //alert("error");
        });
    },
  },
};
</script>
<style scoped>
</style>